import type { ReactElement } from 'react';

import type { FilterDropdownOption } from '@/components/FilterDropdown/FilterDropdown';
import FilterDropdown from '@/components/FilterDropdown/FilterDropdown';

export interface TypeFilterDropdownProps {
  selectedTypes: string[];
  onToggle: (type: string) => void;
  onClear: () => void;
  className?: string;
}

const iconStyle = { fontSize: '14px', color: '#9ca3af' };
const badgeClass = 'bg-zinc-500/20 text-zinc-300';

const TYPE_OPTIONS: FilterDropdownOption[] = [
  {
    value: 'creature',
    label: 'Creature',
    badgeClassName: badgeClass,
    icon: <i className="ms ms-creature ms-fw" style={iconStyle} aria-hidden="true" />,
  },
  {
    value: 'instant',
    label: 'Instant',
    badgeClassName: badgeClass,
    icon: <i className="ms ms-instant ms-fw" style={iconStyle} aria-hidden="true" />,
  },
  {
    value: 'sorcery',
    label: 'Sorcery',
    badgeClassName: badgeClass,
    icon: <i className="ms ms-sorcery ms-fw" style={iconStyle} aria-hidden="true" />,
  },
  {
    value: 'enchantment',
    label: 'Enchantment',
    badgeClassName: badgeClass,
    icon: <i className="ms ms-enchantment ms-fw" style={iconStyle} aria-hidden="true" />,
  },
  {
    value: 'artifact',
    label: 'Artifact',
    badgeClassName: badgeClass,
    icon: <i className="ms ms-artifact ms-fw" style={iconStyle} aria-hidden="true" />,
  },
  {
    value: 'land',
    label: 'Land',
    badgeClassName: badgeClass,
    icon: <i className="ms ms-land ms-fw" style={iconStyle} aria-hidden="true" />,
  },
  {
    value: 'planeswalker',
    label: 'Planeswalker',
    badgeClassName: badgeClass,
    icon: <i className="ms ms-planeswalker ms-fw" style={iconStyle} aria-hidden="true" />,
  },
  {
    value: 'battle',
    label: 'Battle',
    badgeClassName: badgeClass,
    icon: <i className="ms ms-ability-battle-cry ms-fw" style={iconStyle} aria-hidden="true" />,
  },
];

const TRIGGER_ICON = <i className="ms ms-creature ms-fw" style={{ fontSize: '14px' }} aria-hidden="true" />;

export default function TypeFilterDropdown({ selectedTypes, onToggle, onClear, className }: TypeFilterDropdownProps): ReactElement {
  return (
    <FilterDropdown
      triggerLabel="Types"
      triggerIcon={TRIGGER_ICON}
      ariaLabel="Card type filter"
      searchPlaceholder="Search types..."
      options={TYPE_OPTIONS}
      selectedValues={selectedTypes}
      onToggle={onToggle}
      onClear={onClear}
      className={className}
    />
  );
}
